import React from "react";
import { ModeToggle } from "./mode-toggle";
import { UserButton, SignedIn } from "@clerk/clerk-react";
import { Logo } from "@/components/ui/logo";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";

interface SiteHeaderProps {
  className?: string;
}

export const SiteHeader: React.FC<SiteHeaderProps> = ({ className }) => {
  return (
    <header
      className={cn(
        "flex h-16 shrink-0 items-center gap-2 bg-white dark:bg-slate-900 backdrop-blur-xl border-b border-slate-200 dark:border-slate-800 z-10",
        className,
      )}
    >
      <div
        className="flex items-center gap-2 px-8 ml-4 cursor-pointer transition-opacity hover:opacity-80"
        onClick={() => (window.location.href = "/")}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            window.location.href = "/";
          }
        }}
        aria-label="Go to homepage"
      >
        <Logo className="h-8 w-auto max-w-[140px]" />
      </div>

      <div className="ml-auto flex items-center gap-5 px-4">
        <SignedIn>
          <Link to="/billing">
            <Button
              className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 
        shadow-sm hover:shadow-md transition-all duration-200 ease-in-out 
        transform hover:-translate-y-[1px] hover:scale-[1.02] 
        hover:bg-slate-100 dark:hover:bg-slate-700"
            >
              Subscribe
            </Button>
          </Link>
        </SignedIn>

        <UserButton
          appearance={{
            elements: {
              avatarBox: "h-8 w-8",
            },
          }}
        />
        <ModeToggle />
      </div>
    </header>
  );
};
